(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eyyo-hanging-rack"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeRack = (section) => {
      if (!section || section.dataset.rackReady === 'true') return;
      section.dataset.rackReady = 'true';

      section.querySelectorAll('[data-rack-open]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = document.getElementById(button.dataset.rackOpen);
          if (!dialog) return;

          const openDialog = () => {
            dialog.showModal();
            document.documentElement.style.overflow = 'hidden';
          };
          const image = button.querySelector('.eyyo-hanging-rack__image');
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          if (!image || reducedMotion) {
            openDialog();
            return;
          }
          if (button.dataset.rackOpening === 'true') return;

          button.dataset.rackOpening = 'true';
          button.setAttribute('aria-busy', 'true');
          button.classList.remove('is-swinging');
          void image.offsetWidth;
          button.classList.add('is-swinging');

          let fallbackTimer;
          let completed = false;
          const finishOpening = () => {
            if (completed) return;
            completed = true;
            window.clearTimeout(fallbackTimer);
            button.classList.remove('is-swinging');
            button.removeAttribute('aria-busy');
            delete button.dataset.rackOpening;
            openDialog();
          };

          image.addEventListener('animationend', finishOpening, { once: true });
          fallbackTimer = window.setTimeout(finishOpening, 950);
        });
      });

      section.querySelectorAll('[data-rack-dialog]').forEach((dialog) => {
        const closeDialog = () => dialog.close();

        dialog.querySelector('[data-rack-close]')?.addEventListener('click', closeDialog);
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeDialog();
        });
        dialog.addEventListener('close', () => { document.documentElement.style.overflow = ''; });

        const media = dialog.querySelector('.eyyo-rack-dialog__media');
        const frontImage = dialog.querySelector('[data-rack-view-image="front"]');
        const backImage = dialog.querySelector('[data-rack-view-image="back"]');
        const titleOutput = dialog.querySelector('[data-rack-title-output]');
        const priceOutput = dialog.querySelector('[data-rack-price-output]');
        const detailsLink = dialog.querySelector('[data-rack-details]');
        const form = dialog.querySelector('[data-rack-form]');
        const sizeContainer = dialog.querySelector('[data-rack-sizes]');
        const variantInput = dialog.querySelector('input[name="id"]');
        const submitButton = dialog.querySelector('[data-rack-submit]');

        const showView = (nextView) => {
          dialog.querySelectorAll('[data-rack-view]').forEach((viewButton) => {
            const active = viewButton.dataset.rackView === nextView;
            viewButton.classList.toggle('is-active', active);
            viewButton.setAttribute('aria-pressed', String(active));
          });
          dialog.querySelectorAll('[data-rack-view-image]').forEach((image) => {
            image.hidden = image.dataset.rackViewImage !== nextView;
          });
        };

        const resetVariantSelection = () => {
          if (variantInput) variantInput.value = '';
          if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = 'BEDEN SEÇİN';
          }
        };

        dialog.querySelectorAll('[data-rack-view]').forEach((button) => {
          button.addEventListener('click', () => showView(button.dataset.rackView));
        });

        form?.addEventListener('click', (event) => {
          const button = event.target.closest('[data-rack-variant]');
          if (!button || button.disabled || !form.contains(button)) return;

          dialog.querySelectorAll('[data-rack-variant]').forEach((variantButton) => {
            const selected = variantButton === button;
            variantButton.classList.toggle('is-selected', selected);
            variantButton.setAttribute('aria-pressed', String(selected));
          });
          if (variantInput) variantInput.value = button.dataset.rackVariant;
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = 'SEPETE EKLE';
          }
        });

        let colorTimer;
        dialog.querySelectorAll('[data-rack-color]').forEach((colorButton) => {
          colorButton.addEventListener('click', () => {
            if (colorButton.classList.contains('is-active')) return;

            const template = dialog.querySelector(
              'template[data-rack-variants-template="' + colorButton.dataset.rackColor + '"]'
            );
            if (!template) return;

            window.clearTimeout(colorTimer);
            media?.classList.add('is-switching');

            const delay = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180;
            colorTimer = window.setTimeout(() => {
              const nextTitle = colorButton.dataset.rackTitle || '';
              if (frontImage) {
                frontImage.src = colorButton.dataset.rackFront || '';
                frontImage.alt = nextTitle + ' ön görünüm';
              }
              if (backImage) {
                backImage.src = colorButton.dataset.rackBack || '';
                backImage.alt = nextTitle + ' arka görünüm';
              }
              if (titleOutput) titleOutput.textContent = nextTitle;
              if (priceOutput) priceOutput.textContent = colorButton.dataset.rackPrice || '';
              if (detailsLink) detailsLink.href = colorButton.dataset.rackUrl || '#';
              dialog.style.setProperty('--rack-selected-color', colorButton.dataset.rackBackground || '#e8dfcf');
              sizeContainer?.replaceChildren(template.content.cloneNode(true));

              dialog.querySelectorAll('[data-rack-color]').forEach((button) => {
                const active = button === colorButton;
                button.classList.toggle('is-active', active);
                button.setAttribute('aria-pressed', String(active));
              });

              resetVariantSelection();
              showView('front');
              window.requestAnimationFrame(() => {
                window.requestAnimationFrame(() => media?.classList.remove('is-switching'));
              });
            }, delay);
          });
        });
      });
    };

    document.querySelectorAll('[data-eyyo-rack]').forEach(initializeRack);
    document.addEventListener('shopify:section:load', (event) => {
      initializeRack(event.target.querySelector('[data-eyyo-rack]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
